import { InjectionToken } from '@angular/core'
import { Observable } from 'rxjs'
import { CreateEMMASimulation, CreateSmardDataDevice, EMMASimulation, EMSStoreErrorState, InitiallyUndefiedBoolean, SmardDataDevice } from '../types'

export interface SimulatorPort {
  // Observables
  readonly simulations$: Observable<EMMASimulation[] | false>
  readonly smardDataDevices$: Observable<SmardDataDevice[] | false>
  readonly errorState$: Observable<EMSStoreErrorState>
  readonly storeInitialised$: Observable<InitiallyUndefiedBoolean>

  // Simulation operations
  getEMMASimulations(): Observable<EMMASimulation[]>
  patchEMMASimulationName(simulation: EMMASimulation, newName: string): Observable<any>
  patchEMMASimulation(simulation: EMMASimulation): Observable<any>
  createEMMASimulation(simulation: CreateEMMASimulation, deviceCount: number, yearCount: number): Observable<any>
  deleteSimulation(simulation: EMMASimulation): Observable<any>

  // SMARD data device operations
  getSmardDataDevices(): Observable<SmardDataDevice[]>
  createSmardDataDevice(device: CreateSmardDataDevice): Observable<any>
  deleteSmardDataDevice(device: SmardDataDevice): Observable<any>
  resendSmardDataDevice(device: SmardDataDevice): Observable<any>
}

export const SIMULATOR_PORT = new InjectionToken<SimulatorPort>('SimulatorPort')
